<template>
  <div id="loader-container" class="overlay-loader">
    <div class="loader"></div>
  </div>
</template>
